import _ from "lodash";
import type { FC } from "react";
import DownloadIcon from "../../../assets/Icon-Red_Hat-Download-A-Red-RGB.png";
import type { DragHandleProps } from "../../../constants/CardsStructure";
import { usePartnerInfo } from "../../../queries/partnerInfo";
import Env from "../../../utils/env";
import { DashboardCard, type DashboardCardLink } from "../shared/DashboardCard";

export const PartnerSubscriptionsCard: FC<{ dragHandleProps?: DragHandleProps | undefined }> = ({
	dragHandleProps,
}) => {
	const { data: partnerInformationDetails, isFetching: partnerInfoLoading } = usePartnerInfo();
	const orgAdmin = partnerInformationDetails?.orgAdmin;
	const activeEndSubscriptionDate = new Date(
		_.sortBy(partnerInformationDetails?.subscriptionStatus?.subscriptions, "effectiveEndDate")[0]?.effectiveEndDate,
	).toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" });

	const subscriptionStatus = partnerInformationDetails?.subscriptionStatus;

	let description: string | undefined;
	let footerLink: DashboardCardLink | undefined;

	if (!partnerInfoLoading && partnerInformationDetails) {
		if (subscriptionStatus && subscriptionStatus.statusDetail !== "SUCCESS") {
			description = "Unable to load subscription information. Please try again later.";
		} else if (subscriptionStatus?.active && !subscriptionStatus?.available) {
			description = `Your subscription is active. It expires on ${activeEndSubscriptionDate}`;
			footerLink = { label: "Download software", href: `${Env.AccessRedhatPortals[Env.getEnvName()]}downloads` };
		} else if (subscriptionStatus?.available && orgAdmin) {
			description = "Your subscription is not active. Request to access and download free software.";
			footerLink = {
				label: "Request software",
				href: `${Env.ConnectPortalUrls[Env.getEnvName()]}partner-apps/subscriptions`,
			};
		} else if (subscriptionStatus?.available && !orgAdmin) {
			description =
				"Your subscription is not active. Your organization administrator needs to request the subscription.";
		}
	}

	if (!partnerInfoLoading && !description) return null;

	return (
		<DashboardCard
			icon={DownloadIcon}
			title="Partner subscriptions"
			{...(description !== undefined && { description })}
			isLoading={partnerInfoLoading}
			{...(footerLink !== undefined && { footerLinks: [footerLink] })}
			{...(dragHandleProps !== undefined && { dragHandleProps })}
		/>
	);
};
